import React from 'react'
import { Badge } from 'react-bootstrap'

export type StatusColors = {
  background: string
  color: string
}

type StatusBadgeProps<T> = {
  status: T
  label: string
  getStatusColor: (status: T) => StatusColors
}

export const StatusBadge = React.memo(<T,>({ status, label, getStatusColor }: StatusBadgeProps<T>) => {
  const colors = getStatusColor(status)

  const badgeStyle: React.CSSProperties = {
    background: colors.background,
    color: colors.color,
    padding: '8px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    minWidth: '100px',
    display: 'inline-block',
    textAlign: 'center',
    border: 'none',
  }

  return (
    <Badge bg="none" style={badgeStyle}>
      {label}
    </Badge>
  )
}) as <T>(props: StatusBadgeProps<T>) => JSX.Element
